import dashboardService from "@/services/dashboard";
import { useQuery } from "@tanstack/react-query";

function useGetCustomerCount() {
  const { data, isLoading, refetch } = useQuery(
    ["getCustomerCount"],
    dashboardService.dashboardCountInfo
  );
  return { data: data as Record<string, string>, isLoading, refetch };
}

export default useGetCustomerCount;
